// extracted by mini-css-extract-plugin
module.exports = {"upload":"Metaverse3DEditorSidePanel_upload__2xJi4","autosave":"Metaverse3DEditorSidePanel_autosave__3ec3g"};